import Star from "../../../components/Atomos/Icons/Star";

export default function MyWsgCardBadge({ title }: { title: string }) {
  return (
    <div className="flex bg-primary-light rounded-md py-1 px-2 mb-2 w-fit">
      <span className="w-4 h-4 mr-1 text-primary">
        <Star />
      </span>
      <span className="text-sm font-bold">{title}</span>
    </div>
  );
}
